import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { CheckinWaitingSearchSubHeaderComponent } from './checkin-waiting-search-sub-header.component';
import { RouterModule } from '@angular/router';
import { StaticMsgModule } from '@lib/pipes';

@NgModule({
  declarations: [CheckinWaitingSearchSubHeaderComponent],
  imports: [CommonModule, RouterModule, StaticMsgModule],
  exports: [CheckinWaitingSearchSubHeaderComponent],
})
export class CheckinWaitingSearchSubHeaderModule {}
